import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import action from './action'
import Imagepath from '@/assets/js/image.js'

Vue.use(Vuex);
const state = {
  cssstyle: 'green',
  imagestyle: Imagepath,
  usemessage: '',
  doubleCurrentStatus:'双流功能',
  meeting: {
    cfparty: '',
    cfpartyname: '',
    cfhost: '',
    cfhostname: '',
    cfterminal: '',
    cfterminalname: ''
  },
  hasmediasuite: true,
  serverurl: '',
  Screenstatus:true,//默认竖屏状态
  TremianlId:'',
  dmaDomain:''
};
export default new Vuex.Store({
  state,
  action,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js